import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-01-22'
        tag='Poshmark'
        title="Everything You Need to Know About Poshmrk's Closet Insights"
      >
        <p>
          "Poshmark allows you to manage your closet from anywhere you have an internet connection. In this blog, we
          have listed some simple tips for you to get the most out of Poshmark."
        </p>
        <p>
          Poshmark is a well-known US-based online social marketplace. That is similar to platforms like eBay, ThredUp,
          and Etsy. Poshmark is no stranger to rolling out a suite of seller-focused product and feature releases
          designed to provide new levels of growth for casual sellers with more customer insights. To help them better
          achieve their aspirations to turn from casual selling to becoming a full-time entrepreneur.
        </p>

        <h3>How My Closet Insights Work</h3>
        <p>
          To aid their seller community they came out with Poshmark’s version of integrative insights relevant tools
          called “My Closet Insights” this dynamic dashboard generates real-time inventory data and sales with
          razor-like precision for you to better understand your Poshmark sales, sales funnel, and your closet
          performance. This is designed to be the next iteration of the Poshmark experience because it is not just
          limited to sales data and inventory summaries.
        </p>
        <p>
          You can also utilize key insights that you can use to improve and optimize your orders, style tags, listing
          videos, and more. Specially designed to help you attain new levels of success with customers and provide a
          better retail experience.
        </p>
        <p>
          According to Poshmark co-founder and senior vice president of seller experience Tracy Sun, sellers are the
          heart and soul of the Poshmark community, and that the platform is committed to helping merchants thrive at
          every step of their journey.
        </p>
        <p>
          At the helm of the seller experience is a passion for innovation and robust support both of which Poshmark is
          keen to deliver on. This is because, in addition to launching these sales insight tools, Poshmark has also
          formed a seller experience team across the US, Canada, Australia, and India to not only support sellers but
          spearhead their transition to participation in the digital economy as the future of shopping to be able to
          leverage their selling experience in a seamless and sustainable way.
        </p>
        <p>
          The company offers new and pre-owned apparel (both of smaller and larger brand), accessories, and shoes for
          both women and men as well as kids, and many more products ranging from goods for pets, beauty, and home decor
          items. It now has more than 80 million registered users across the US, Canada, Australia, and India with
          operations in the latter starting last August.
        </p>
        <p>
          Each of these insight tools will be created in the dashboard in a visual chart format so you can easily filter
          your charts based on the time period and other specific criteria.
        </p>
        <h4>Types of charts:</h4>
        <ul>
          <li>
            Sales Summary & Comparison - An overview of sold listings and earnings. Sellers can filter the data by a
            specific time range and easily compare it to the past year.
          </li>
          <li>
            Brand Insights Chart - An overview of sold listings and earnings that can also be filtered by a specific
            time range and easily compare it to the past year.
          </li>
          <li>
            Sales Insights Chart - Sellers can find their top-selling categories according to sales, average sales
            price, and listings sold here. And you can filter your sales by item condition and more.
          </li>
          <li>
            Other Insights Chart - Sellers can determine how buyers typically purchase items in your closet. Via the buy
            now, bundle, bundle offer, or bundle buy now.
          </li>
          <li>
            Inventory Summary Chart - Similar to the Sales Summary Chart, this is an overview of your current and past
            inventory counts so you can easily manage your stock.
          </li>
          <li>
            Listing Insights Chart - With your listings being made up of categories you can easily filter them by value,
            average item price, or available listings.
          </li>
        </ul>

        <h3>How to Use My Closet Insights</h3>
        <h4>Pricing</h4>
        <p>
          When it comes to pricing your products it is beneficial to understand the cost of goods and the average order
          value by brand or category to be able to optimize your pricing strategies. You can do this by using the Sales
          and Brand Insights Chart.
        </p>
        <h4>Merchandising</h4>
        <p>
          To be able to determine which trends, brands, and inventory are popular or relevant based on seasonal time
          periods you can use the Sales, Brand Insights, Sales Insights, Inventory, and Brand *Listing Insights charts
          to be able to make your comparisons and gather data.
        </p>
        <h4>Marketing & Promotions</h4>
        <p>
          As a seller it is important to not only know what sells and when but also to be able to create strategies the
          will positively impact your traffic and sales. For this, you can use the Sales Summary & Comparison chart.
        </p>

        <p>
          If you want to review sales trends on days that you run promotional discounts, offers to likers, and price
          drops and see how your business performance the ideal chart to consult would be the Order Insights.
        </p>
        <p>
          Poshmark is a social commerce marketplace that is not short when it comes to innovations, in fact, they are a
          trailblazer when it comes to enhancing their platform to give the optimum seller and shoppers experience. They
          create annual events like Poshfest to inspire and connect anyone who’s interested in starting their own
          business with fellow business savvy style mavens. And learn how to grow a business and be their own boss
          straight from the pros themselves. This coupled with its innovative insights tool is good news because as a
          seller, it is a great asset to be able to have the tools that you can use to grow and further enhance your
          business.
        </p>
        <p>
          However, it takes focus and a dedication of time to navigate through all these new technologies and transition
          your operations to them. So if you’re just starting out or need to learn the tricks of the trade to get repeat
          customers, OneShop is a great software to get you started and achieve your ambition for your business.{' '}
        </p>
        <p>
          With its easy-to-use interface and readily customizable tools so without worry you can leave the manual but
          valuable time-consuming tasks like bulk listing actions behind so you can free up more spare time to focus on
          more important things to grow your business like upgrading your digital presence to Facebook and Instagram.
          OneShop also functions as your virtual assistant that works 24/7 to improve your reach by automating shares,
          follows, and more!
        </p>
        <p>
          Try it for yourself, register for free, and enjoy a 7-day trial with no commitment or credit card required.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
